import { createContext, useEffect, useState } from "react";
import { routePaths } from "src/utils/constants";
import { useLocation } from 'react-router-dom';

type LocationProviderProps = React.PropsWithChildren & {
   currentPath: string | null
}

const LocationContext = createContext<LocationProviderProps | null>({
   currentPath: null
})

const LocationProvider: React.FC<LocationProviderProps> = ({ children }) => {
   const location = useLocation();

   const [prevLocation, setPrevLocation] = useState<string | null>(sessionStorage.getItem('previousUrl') || null);

   const path = location.pathname + location.search + location.hash

   useEffect(() => {
      // Not store /login /register /logout
      if (!path?.includes(routePaths.LOGIN_PAGE) && !path?.includes(routePaths.LOGOUT_PAGE) && !path?.includes(routePaths.REGISTER_PAGE)) {
         setPrevLocation(path);

         sessionStorage.setItem('previousUrl', path);
      }
   }, [path]);

   return (
      <LocationContext.Provider value={{ currentPath: prevLocation }}>
         {children}
      </LocationContext.Provider>
   );
};

// eslint-disable-next-line react-refresh/only-export-components -- co-located with its provider; splitting would ripple through every import site
export { LocationContext };
export default LocationProvider;